import client from '../httpClient';

// /sms/customer/{smsCustomerId} 【sms009】SMS顧客更新
const smsCustomerUpdateApi = (smsCustomerId, modifyObj) => {
  const UPDATE_SMS_CUSTOMER_URL = `/sms/customer/${String(smsCustomerId)}`;
  return client.put(UPDATE_SMS_CUSTOMER_URL, JSON.stringify(modifyObj), { isShowMessage: true });
};

export default smsCustomerUpdateApi;
